export const PATH_HOME = '/';
export const PATH_ELEV_MEASUREMENTS = '/elevations/measurements';
export const PATH_ELEV_CONFIGURE = '/elevations/configure';
export const PATH_ELEV_RESULTS = '/elevations/results';
